import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export const PageTitle = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 5,
        alignItems: 'center',
      }}
    >
      <Typography variant='h6' color='info.text'>
        <FormattedMessage id='progress-portrait.title' />
      </Typography>
    </Box>
  );
};
